import React, { useState, useEffect } from 'react';
import '../styles/Navbar.css';

function Navbar({ language, onToggleLanguage }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : '';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = '';
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      closeMenu();
    }
  };

  return (
    <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="logo" onClick={() => scrollToSection('home')}>
        <img 
          className="cloud-logo" 
          src="https://raw.githubusercontent.com/Helmifalfie7/nexofortis/main/logodynamics/logo-nexo-modified2.png"
          alt="Nexofortis Logo" 
        />
      </div>

      <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          <li>
            <a onClick={() => scrollToSection('home')}>
              <span lang="en">Home</span>
              <span lang="fr">Accueil</span>
            </a>
          </li>
          <li>
            <a onClick={() => scrollToSection('about')}>
              <span lang="en">About</span>
              <span lang="fr">À propos</span>
            </a>
          </li>
          
          <li>
            <a onClick={() => scrollToSection('values')}>
              <span lang="en">Values</span>
              <span lang="fr">Valeurs</span>
            </a>
          </li>
          <li>
            <a onClick={() => scrollToSection('services')}>
              <span lang="en">Services</span>
              <span lang="fr">Services</span>
            </a>
          </li>
          <li>
            <a onClick={() => scrollToSection('sectors')}>
              <span lang="en">Sectors</span>
              <span lang="fr">Secteurs</span>
            </a>
          </li>
          <li>
            <a onClick={() => scrollToSection('contact')}>
              <span lang="en">Contact</span>
              <span lang="fr">Contact</span>
            </a>
          </li>
        </ul>
      </nav>

      <button className="lang-toggle" onClick={onToggleLanguage}>
        <img 
          src={language === 'en' 
            ? 'https://flagcdn.com/w40/gb.png' 
            : 'https://flagcdn.com/w40/fr.png'
          } 
          alt={language === 'en' ? 'English' : 'Français'} 
        />
      </button>

      <div 
        className={`hamburger ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
}

export default Navbar;
